import 'app.scss'

import $ from 'jquery'
import moment from 'moment'

import Vue from 'vue'
import VueRouter from 'vue-router'

import 'select2'
import 'select2/dist/css/select2.css'
import 'select2/dist/js/i18n/ja.js'

Vue.use(VueRouter)

Vue.filter('dateformat', (value, format) => {
  return moment(value).format(format)
})

Vue.directive('select', {
  twoWay: true,
  priority: 1000,
  params: ['data', 'placeholder'],
  bind: function () {
    var self = this
    $(this.el).select2({
      language: 'ja',
      dropdownParent: $(this.el).parent(),
      data: this.params.data,
      allowClear: true,
      placeholder: this.params.placeholder,
    }).on('change', function () {
      self.set(this.value)
    })
  },
  update: function (value) {
    $(this.el).val(value).trigger('change')
  },
  unbind: function () {
    $(this.el).off().select2('destroy')
  }
})

let locale = window.navigator.userLanguage || window.navigator.language;
moment.locale(locale)
require("moment-range")

$(function() {
  var App = Vue.extend(require('app.vue'))
  var router = new VueRouter({
    hashbang: false,
    history: true,
  })

  router.map({
    '/': {
      name: 'index',
      component: require('index/index.vue'),
    },
    '/customer/': {
      name: 'customer',
      component: require('customer/index.vue'),
    },
    '/reservations/:shopId/:year/:month/:day': {
      name: 'reservations',
      component: require('reservations/index.vue'),
    },
    '/informations/:shopId': {
      name: 'informations',
      component: require('informations/index.vue'),
    },
    '/login': {
      name: 'login',
      component: require('account/login.vue'),
    },
    '/account/password': {
      name: 'password',
      component: require('account/password.vue'),
    },
    '/shift': {
      name: 'shift',
      component: require('shift.vue'),
    },
  })

  router.start(App, '#app')
})

if (DEBUG) {
   window._vue = Vue
   window._moment = moment
   window._jquery = $
}



// WEBPACK FOOTER //
// ./app.js